const FRONTMATTER_RE = /^---\n([\s\S]*?)\n---\n/;

export function parseFrontmatter(raw: string): {
  data: Record<string, string>;
  content: string;
} {
  const match = FRONTMATTER_RE.exec(raw);
  if (!match) return { data: {}, content: raw };

  const data: Record<string, string> = {};
  for (const line of (match[1] ?? "").split("\n")) {
    const idx = line.indexOf(":");
    if (idx === -1) continue;
    data[line.slice(0, idx).trim()] = line.slice(idx + 1).trim();
  }
  return { data, content: raw.slice(match[0].length) };
}
